module.exports = __webpack_public_path__ + "static/media/rnb_temp.d8fd8f0c.jpg";